import axios from 'axios'
import { store } from '../store/store'
import crypto from 'crypto-js'
import { EVENT_URL, MOBILE_API_URL, SHEET_SERVER_URL } from './apiEnum'
import { getToastRef } from '../context/ToastContext'
import { signOut } from './auth'
import { setLastUsedWorkspaces } from '../utils'
import { logout } from '../store/actions/authActions'

export const corsairClient = (() =>
    axios.create({
        baseURL: process.env.REACT_APP_SCOOP_API,
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    }))()

corsairClient.interceptors.request.use(
    (config) => {
        const isDev = process.env.REACT_APP_SCOOP_ENV === 'dev'
        const token = store.getState().auth.token || localStorage.getItem('userToken')
        // Defensive: check token exists before accessing .length
        const isGuest = token && token.length < 100
        if (token) config.headers.Authorization = `Bearer ${token}`
        switch (config.method) {
            case 'put':
            case 'post':
                // Defensive: ensure config.data exists
                if (!config.data) {
                    config.data = {}
                }
                config.data.isDev = isDev
                if (config.url === EVENT_URL) {
                    const passkey = 'omega145022'
                    // Defensive: ensure config.data.data exists before encrypting
                    if (config.data.data) {
                        config.data.data = crypto.AES.encrypt(
                            JSON.stringify(config.data.data),
                            passkey
                        ).toString()
                    }
                    return config
                } else {
                    if (
                        isDev &&
                        (config.url === SHEET_SERVER_URL || config.url === MOBILE_API_URL)
                    ) {
                        config.url = config.url + 'dev'
                    }
                    if (isGuest) {
                        const [slash, url] = config.url.split('/')
                        config.url = `${slash}guest-${url}`
                    }
                    const userID = localStorage.getItem('userID')
                    const workspaceID = localStorage.getItem('workspaceID')
                    if (config.data.skipUserIDOverride) {
                        delete config.data.skipUserIDOverride
                    } else {
                        if (userID) config.data.userID = userID
                    }
                    if (config.data.isPolling) {
                        // Clean up the isPolling flag after checking
                        delete config.data.isPolling
                    } else if (config.data.skipWorkspaceIDOverride) {
                        // If explicitly requested, don't override workspaceID
                        delete config.data.skipWorkspaceIDOverride
                    } else {
                        if (workspaceID) config.data.workspaceID = workspaceID
                    }
                    return config
                }
            case 'get':
                return config
            case 'delete':
                return config
        }
    },
    (error) => {
        return Promise.reject(error)
    }
)

// Axios interceptors run outside the React tree, so we access
// Redux via store directly and toasts via getToastRef()
corsairClient.interceptors.response.use(
    (res) => {
        return res
    },
    async (error) => {
        const status = error.response ? error.response.status : null
        const toast = getToastRef()

        if (status === 401) {
            const state = store.getState()
            const { workspaceID, userID, workspaceName } = state.auth

            if (toast) {
                toast.show('Your session has expired. Please log in again.', 'error')
            }
            signOut().then(() => {
                setLastUsedWorkspaces(userID, workspaceID, workspaceName)
                store.dispatch(logout())
            })
        }
        if (status === 403 && error.response.data) {
            return Promise.reject(error.response.data)
        }
        if (status === 502) {
            if (toast) {
                toast.show('Something went wrong on our side. Please try again later.', 'error')
            }
            return Promise.reject(error.response.data)
        }
        return Promise.reject(error)
    }
)

export const helpBotClient = axios.create({
    baseURL: process.env.REACT_APP_HELP_BOT_ENDPOINT,
    headers: {
        'Content-Type': 'application/json',
    },
})
